<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[contractcums$]"></ef-loading-container>
<ef-loading
    [processing]="IsLoading"
    [processingText]="commitText"
    [loading]="IsLoading"
></ef-loading>
<ef-contract-cumulative-presenter
  [reports]="reports$ | async"
  [contractcums] = 'contractcums$ | async'
  [contracts] = 'contracts$ | async'
  [tasks] = 'tasks$ | async'
  [IsFeatureLoading] = 'IsLoading'
  [txntypes] = 'txntypes$ | async'
  [userGroups] = 'userGroups$ | async'
  [sessionDates] = 'sessionDates$ | async'
  [directreports] = 'directreports$ | async'
  [serviceitems] = 'serviceitems$ | async'
  [process] = 'process$ | async'
  (Timer)="onTimer($event)"
  (LoadSessionDates)="onLoadSessionDates($event)"
  (SaveContractCums)="onSaveContractCums($event)"
  (LoadContractCums)="onLoadContractCums($event)"
  (LoadAllContractCums)="onLoadAllContractCums($event)"
  (DeleteContractCum)="onDeleteContractCum($event)"
  (LoadDirectOrIndirect)="onLoadDirectOrIndirect($event)"
  [selectedError]="selectedErrorWithStatus$ | async"
  (ShowError)="this.ShowError.next($event)"
  (CommitCumulatives)="onCommitCumulatives($event)"
  (RunReports)="onRunReports($event)"
  (uploadJSON)="onUploadJSON($event)"
>
</ef-contract-cumulative-presenter>
